import { Card, Flexbox } from '@/components'
import dateMask from '@/lib/masks/date'
import PropTypes from 'prop-types'
import React from 'react'

export default function CastrationCard({ data }) {
  return (
    <Card.Base>
      <Card.Header>
        <Flexbox.Columns className="align-center">
          <Flexbox.Column>
            <div className="h6 card-title">Detalhes da castração</div>
          </Flexbox.Column>
          <Flexbox.Column className="col-auto">
            <i className="fas fa-book-medical" />
          </Flexbox.Column>
        </Flexbox.Columns>
      </Card.Header>
      <Card.Body>
        <small>
          <Flexbox.Columns>
            <Flexbox.Column className="col-12">Realizada em: <b>{dateMask(data?.castratedAt)}</b></Flexbox.Column>
            <Flexbox.Column className="col-12 divider text-center" data-content="Termos" />
            <Flexbox.Column className="col-12 mt-1">
              <div className="pre">
                {data?.terms || '-'}
              </div>
            </Flexbox.Column>
            <Flexbox.Column className="col-12 divider text-center" data-content="Observações" />
            <Flexbox.Column className="col-12 mt-1">
              <div className="pre">
                {data?.obs || '-'}
              </div>
            </Flexbox.Column>
          </Flexbox.Columns>
        </small>
      </Card.Body>
    </Card.Base>
  )
}

CastrationCard.propTypes = {
  data: PropTypes.objectOf(Object).isRequired,
}
